import React, { Component, createRef  } from 'react';
import { withRouter, setCookie, login_check, loginUrl, pocketUrl, isLogin, deleteCookie, addToWordCookie, getCookieCross } from './include/Common';
import {Helmet} from 'react-helmet';

import $ from 'jquery';
import axios from "axios";
import { Navigate } from "react-router-dom";
import Footer from './Footer';

class TodayCross extends Component {
   constructor(props) {
      super(props);
      this.popupRef = createRef();

      this.state = {
         isLogin: false,   // 처음에 로딩 상태
         loading: true,
         grid: [],
         keywords: [],
         focusedCells: [],
         selectedWord: null,
         selectChoung: '',
         selectDesc: '',
         quizWeek: '',
         ord: 'all',
         currDate: '',
         tcount: 0,
         formatted: '',
         formMonth: '',
         formWeek: '',
         loginCheck: false,
         revealedCount: 0,
      };
   }
   componentDidMount() {
      // 페이지 로드 시 axios 호출
      const popup = this.popupRef.current;

      if (popup) {
         popup.addEventListener("focusin", this.handleFocusIn);
         popup.addEventListener("focusout", this.handleFocusOut);
      }      
      this.loadScript();
      $('.hint-btn').on('click', function () {
         $(this).addClass('show');
      });
      function close_quiz_popup() {
         $('.crossword__popup').hide();
         $('.hint-btn').removeClass('show');
         $('body').css('overflow', 'auto');
         return false;
      }
      //  팝업 영역 외 클릭시 닫기
      $('.crossword__popup').on('click', function (e) {
         if (!$(e.target).closest('.popup__wrap').length) {
            close_quiz_popup();
         }
      });
//
      $('.crossword__popup .close').on('click', function () {
         close_quiz_popup();
      });
      $('.info-toggle-btn').on('click', function (e) {
         if (!$(e.target).closest('.info-toggle-btn.active').length) {
            $('.info-toggle-btn').removeClass('active');
         }
      });
      $(document).on('click', function (e) {
         // active 버튼이 있는 경우
         if ($('.info-toggle-btn.active').length > 0) {
            // 클릭한 요소가 active 버튼이 아닌 경우
            if (!$(e.target).closest('.info-toggle-btn.active').length) {
               $('.info-toggle-btn').removeClass('active');
            }
         }
      });
      // 캘린더 닫기버튼 추가
      function insertCloseButton(instance) {
         const calendar = instance.calendarContainer;
         if (!calendar.querySelector('.flatpickr-close-btn')) {
            const closeBtn = document.createElement('button');
            closeBtn.title = '닫기';
            closeBtn.className = 'flatpickr-close-btn';
            closeBtn.addEventListener('click', () => {
               instance.close();
            });
            calendar.appendChild(closeBtn);
         }
      }

      // 주의 시작일 (월요일) 반환
      function getStartOfWeek(d) {
         const date = new Date(d);
         const day = date.getDay(); // 일:0 ~ 토:6
         const diff = (day === 0 ? -6 : 1) - day; // 월요일 시작
         date.setDate(date.getDate() + diff);
         date.setHours(0, 0, 0, 0);
         return date;
      }
      function getEndOfWeek(date) {
         const start = getStartOfWeek(date);
         return new Date(start.getFullYear(), start.getMonth(), start.getDate() + 6);
      }
      // 이번 주의 마지막 날 계산 (일요일)
      function getEndOfThisWeek() {
         const now = new Date();
         const start = getStartOfWeek(now);
         return new Date(start.getFullYear(), start.getMonth(), start.getDate() + 6);
      }

      // flatpickr 헤더 커스터마이징 (옵션용)
      function updateHeader(selectedDates, dateStr, instance) {
         const monthElement = instance.currentMonth;
         const year = instance.currentYear;
         const koreanMonths = ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'];
         const customLabel = `${year}년 ${koreanMonths[monthElement]}`;

         const currentMonthElem = instance.calendarContainer.querySelector('.flatpickr-current-month');
         if (currentMonthElem) {
            currentMonthElem.innerHTML = `<span class="cur-month">${customLabel}</span>`;
         }
      }

      // 초기 설정
      const maxDate = getEndOfThisWeek();
      let currentDate = getStartOfWeek(new Date());

      const fp = window.flatpickr('#weekPicker', {
         dateFormat: 'Y-m-d',
         locale: {
            ...window.flatpickr.l10ns.ko,
            firstDayOfWeek: 1, // 월요일 시작
         },
         weekNumbers: true,

         defaultDate: currentDate,
         maxDate,
         plugins: [new window.weekSelect({})],

         onChange: (selectedDates, dateStr, instance) => {
            if (selectedDates.length > 0) {
               const selectedDate = selectedDates[0];

               // 오늘 날짜로 표시할 셀에 today 클래스 부여
               const allDays = instance.calendarContainer.querySelectorAll('.flatpickr-day');
               allDays.forEach((dayElem) => {
                  if (!dayElem.dateObj) return;
                  const dayDate = dayElem.dateObj;
                  dayElem.classList.remove('today', 'week', 'selected');

                  if (
                     dayDate.getFullYear() === selectedDate.getFullYear() &&
                     dayDate.getMonth() === selectedDate.getMonth() &&
                     dayDate.getDate() === selectedDate.getDate()
                  ) {
                     dayElem.classList.add('today');
                  }

                  // 선택된 주 계산
                  const weekStart = getStartOfWeek(selectedDate);
                  const weekEnd = getEndOfWeek(selectedDate);

                  if (dayDate >= weekStart && dayDate <= weekEnd) {
                     dayElem.classList.add('week', 'selected');
                  }
               });
               currentDate = getStartOfWeek(selectedDates[0]);
               const date = (selectedDates instanceof Date) ? selectedDates : new Date(selectedDates);
               const Y = date.getFullYear();
               const m = String(date.getMonth() + 1).padStart(2, '0');
               const d = String(date.getDate()).padStart(2, '0');
               const selDate = `${Y}-${m}-${d}`;

               this.fetchAccessCheck(selDate);

               //updateWeekText(currentDate);
            }
         },
         onMonthChange: updateHeader,
         onYearChange: updateHeader,
         onOpen: updateHeader,
         onReady: function (selectedDates, dateStr, instance) {
            insertCloseButton(instance);

            //updateWeekText(currentDate);
         },
      });
   }
   componentWillUnmount() {
      const popup = this.popupRef.current;

      if (popup) {
         popup.removeEventListener("focusin", this.handleFocusIn);
         popup.removeEventListener("focusout", this.handleFocusOut);
      }

      document.body.style.position = "";
      document.body.style.width = "";
   }

   handleFocusIn = () => {
      // iOS 키보드 올라올 때 body 스크롤 고정
      document.body.style.position = "fixed";
      document.body.style.width = "100%";
   };

   handleFocusOut = () => {
      // 포커스 아웃 시 body 스크롤 복원
      document.body.style.position = "";
      document.body.style.width = "";
   };
   async fetchAccessCheck(currentDate) {
      const publicUrl = process.env.PUBLIC_URL;

      if (currentDate != '') {
         $('.comboBx__btn').text('전체');
         this.setState({
            ord: 'all',
            currDate: currentDate
         });
      }
      const { ord, currDate } = this.state;

      if (currentDate == '' || currentDate == undefined) currentDate = currDate;

      const responseCross = await axios.get(publicUrl + '/api/getCrossWord.php?dt=' + currentDate);
      const cwData = responseCross.data;
      //const t_keyword = JSON.parse(cwData.t_keyword || '[]'); // grid용
      //const keywordJSON = JSON.parse(cwData.keywordJSON || '[]'); // 전체 키워드 및 설명

      let t_keyword = [];

      try {
         const parsed1 = JSON.parse(cwData.t_keyword || '[]');
         if (Array.isArray(parsed1)) {
            t_keyword = parsed1;
         }
      } catch (e) {
         console.error("JSON 파싱 오류:", e);
      }

      let keywordJSON = [];

      try {
         const parsed2 = JSON.parse(cwData.keywordJSON || '[]');
         if (Array.isArray(parsed2)) {
            keywordJSON = parsed2;
         }
      } catch (e) {
         console.error("JSON 파싱 오류:", e);
      }
      // 2. grid 배열 구성
      const grids = t_keyword.map(item => ({
         word: item.word,
         row: item.row,
         col: item.col,
         dir: item.dir
      }));
      const revealedWordsCookie = getCookieCross('wordList'); // 쿠키에서 단어 목록 가져오기
      const revealedWords = revealedWordsCookie ? revealedWordsCookie.split(',') : [];
      const crossDate = cwData.crossDate;
      let cookieWords = '';
      // 3. keywords 배열 구성 (힌트 비활성화 처리 포함)
      const keys = keywordJSON.map(item => {
         let isRevealed = item.isRevealed;

         // isRevealed가 false일 때만 쿠키로 확인
         if (!isRevealed && revealedWords.includes(item.word)) {
            isRevealed = true;
         }

         if (isRevealed) {
            if (cookieWords == '') {
               cookieWords += item.word;
            } else {
               cookieWords += '|' + item.word;
            }
         }
         return {
            word: item.word,
            row: item.row,
            col: item.col,
            dir: item.dir,
            desc: item.desc,
            isRevealed: isRevealed
         };
      });
      if (cookieWords != '') {
         const publicUrl = process.env.PUBLIC_URL;
         let quizWordUrl = publicUrl + '/api/setCrossAnswer.php?week=' + crossDate + '&word=' + cookieWords + '&mode=cross';
         axios.get(quizWordUrl).then(response => {
            if (response.data == 'OK' && revealedWordsCookie) {
               deleteCookie('wordList');
            }
         });
      }

      const remaining = keys.filter(w => !w.isRevealed).length;
      const revealedCount = keys.filter(w => w.isRevealed).length;

      const totalCount = keys.length;
      const percent = Math.round((revealedCount / totalCount) * 100);
      if (cwData.t_count > 0) {
         this.setPercent(percent);
      }
      const retForm = cwData.dateInfo.formatted.split("|");
      const isLogin = login_check();
      this.setState({
         grid: grids,
         keywords: keys,
         quizWeek: cwData.t_year + '' + cwData.t_week,
         formatted: cwData.dateInfo.formatted,
         formMonth: retForm[0],
         formWeek: retForm[1],
         tcount: cwData.t_count,
         remainingCount: remaining,
         solvedPercent: percent,
         loading: false,
         loginCheck: cwData.login,
         revealedCount: revealedCount
      });
   }
   
   setPercent = (percent) => {

      const path = document.querySelector('.pie-chart-line');
      if (path) {
         const lineLength = path.getTotalLength();
         if (percent == 0) {
            path.style.opacity = 0;
         } else {
            path.style.strokeDasharray = lineLength;
            path.style.strokeDashoffset = lineLength;

            setTimeout(() => {
               const offset = lineLength * (1 - percent / 100);
               path.style.strokeDashoffset = offset;
               path.style.opacity = 1;
            }, 100);
         }
      }
   }
   handleCellClick = (e, rowIndex, colIndex, isEmpty) => {
      const { data, grid, keywords, loading, error } = this.state;
      if (!isEmpty) {
         const foundWord = grid.find(({ word, row, col, dir }) => {
            if (dir === 'H') {
               return row === rowIndex && colIndex >= col && colIndex < col + word.length;
            } else if (dir === 'V') {
               return col === colIndex && rowIndex >= row && rowIndex < row + word.length;
            }
            return false;
         });
         const focusCoords = [];
         for (let i = 0; i < foundWord.word.length; i++) {
            const rr = foundWord.dir === 'H' ? foundWord.row : foundWord.row + i;
            const cc = foundWord.dir === 'H' ? foundWord.col + i : foundWord.col;
            focusCoords.push({ row: rr, col: cc });
         }
         /*
         const getChosung = (text) => {
            const CHOSUNG = [
               'ㄱ', 'ㄲ', 'ㄴ', 'ㄷ', 'ㄸ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅃ', 'ㅅ', 'ㅆ',
               'ㅇ', 'ㅈ', 'ㅉ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ'
            ];

            let result = '';
            for (let char of text) {
               const code = char.charCodeAt(0);
               if (code >= 0xac00 && code <= 0xd7a3) {
                  const chosungIndex = Math.floor((code - 0xac00) / 588);
                  result += CHOSUNG[chosungIndex];
               } else {
                  result += char; // 한글이 아니면 그대로
               }
            }
            return result;
         }
         */
         const getChosung = (text) => {
            const CHOSUNG = [
               'ㄱ', 'ㄲ', 'ㄴ', 'ㄷ', 'ㄸ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅃ', 'ㅅ', 'ㅆ',
               'ㅇ', 'ㅈ', 'ㅉ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ'
            ];

            let result = '';
            let firstEng = true;
            for (let i = 0; i < text.length; i++) {
               const char = text[i];
               const code = char.charCodeAt(0);

               // 한글
               if (code >= 0xac00 && code <= 0xd7a3) {
                  const chosungIndex = Math.floor((code - 0xac00) / 588);
                  result += CHOSUNG[chosungIndex];

                  // 영어
               } else if ((char >= 'A' && char <= 'Z') || (char >= 'a' && char <= 'z')) {
                  if (i === 0 || firstEng) {
                     result += char;
                     firstEng = false;
                  } else {
                     result += 'O';
                  }
                  // 숫자
               } else if (char >= '0' && char <= '9') {
                  result += char;

                  // 기타 (기호 등)
               } else {
                  result += char;
               }
            }

            return result;
         };
         if (foundWord) {
            const keywordInfo = keywords.find(k => k.word === foundWord.word);
            const desc = keywordInfo?.desc ?? '(설명 없음)';
            // 예: 팝업을 띄우기 위해 상태를 업데이트할 수도 있음
            if (!keywordInfo?.isRevealed) {
               this.setState({ selectedWord: foundWord, selectChoung: getChosung(foundWord?.word), selectDesc: desc, answers: '', focusedCells: focusCoords, popupVisible: true });
               $('.crossword__popup').stop().show().css('display', 'flex');
               $('.crossword__popup .scroll-bx').scrollTop(0).focus();
               $('body').css('overflow', 'hidden');
               $('#crossword__popup__input').attr('class', '');
               $('#inputAnswer').val('');
               $('#inputAnswer').prop('disabled', false);
               $('#crossword__popup__input').addClass('crossword__popup__input');
            }
         }
      }
   };
   crossWordInputChange = (e) => {
      this.setState({ answers: e.target.value });
      $('.crossword__popup__input').addClass('state--typing');
   }
   crossWordCheckInput = (e) => {
      e.preventDefault(); // a 태그의 기본 동작 막기
      const { answers, selectedWord, grid, keywords } = this.state;
      if (selectedWord?.word.replace(/\s+/g, '').toLowerCase() === answers.replace(/\s+/g, '').toLowerCase()) {
         // 정답
         const updatedKeywords = keywords.map(k =>
            k.word === selectedWord.word ? { ...k, isRevealed: true } : k
         );
         addToWordCookie(selectedWord?.word);
         const revealedCount = updatedKeywords.filter(w => w.isRevealed).length;
         const totalCount = updatedKeywords.length;
         const percent = Math.round((revealedCount / totalCount) * 100);
         const remaining = totalCount - revealedCount;


         const publicUrl = process.env.PUBLIC_URL;
         const crossWordUrl = publicUrl + '/api/setCrossAnswer.php?week=' + this.state.quizWeek + '&word=' + answers + '&mode=cross';
         const response = axios.get(crossWordUrl);
         const retData = response.data;

         $('.crossword__popup__input').addClass('state--pass');
         $('#inputAnswer').prop('disabled', true);
         //2초후 팝업 닫기
         setTimeout(() => {
            $('.crossword__popup').hide();
            $('.hint-btn').removeClass('show');
            $('body').css('overflow', 'auto');

            this.setState({
               keywords: updatedKeywords,
               showPopup: false,
               selectedWord: null,
               focusedCells: [],
               remainingCount: remaining,
               solvedPercent: percent,
               revealedCount: revealedCount,
               answers: ''
            });
            this.setPercent(percent);
         }, 2000);


      } else {
         // 오답
         $('.crossword__popup__input').addClass('state--fail');
         $('#inputAnswer').prop('disabled', true);
         setTimeout(() => {
            //입력가능상태로 되돌리기
            $('.crossword__popup__input').removeClass('state--fail');
            $('#inputAnswer').prop('disabled', false).focus();
            $('.crossword__popup__input').addClass('state--typing');
         }, 2000);
      }
   }
   loadScript() {
      function getStartOfWeek(d) {
         const date = new Date(d);
         const day = date.getDay(); // 일:0 ~ 토:6
         const diff = (day === 0 ? -6 : 1) - day; // 월요일 시작
         date.setDate(date.getDate() + diff);
         date.setHours(0, 0, 0, 0);
         return date;
      }
      function getEndOfWeek(date) {
         const start = getStartOfWeek(date);
         return new Date(start.getFullYear(), start.getMonth(), start.getDate() + 6);
      }

      let currentDate = getStartOfWeek(new Date());
      const cY = currentDate.getFullYear();
      const cm = String(currentDate.getMonth() + 1).padStart(2, '0');
      const cd = String(currentDate.getDate()).padStart(2, '0');
      const curDate = `${cY}-${cm}-${cd}`;

      this.fetchAccessCheck(curDate);
   }

   handelLoginClick = () => {
      const refUrl = process.env.REACT_APP_USER_WWW + '/snslogin/PocketLogingDone.php?loc=MyCross';
      window.location.href = loginUrl + '?ref=' + encodeURIComponent(refUrl);
   }
   render() {
      const { loginCheck, data, grid, keywords, selectedWord, revealedCount, selectChoung, selectDesc, tcount, formMonth, formWeek, popupVisible, loading, error } = this.state;

      const rows = 10;
      const cols = 10;

      // 1. 빈 격자 생성
      const displayGrid = Array.from({ length: rows }, () =>
         Array.from({ length: cols }, () => ' ')
      );
      
      // 2. 단어들 채우기
      grid.forEach(({ word, row, col, dir }) => {
         for (let i = 0; i < word.length; i++) {
            const r = dir === 'H' ? row : row + i;
            const c = dir === 'H' ? col + i : col;
            if (displayGrid[r] && displayGrid[r][c] !== undefined) {
               displayGrid[r][c] = word[i];
            }
         }
      });

      const currentUrl = window.location.href;
      const structureData = {
         "@context": "https://schema.org",
         "@type": "WebSite",
         "name": "주간 십자말풀이 - 지식포켓",
         "url": currentUrl,
      }
      return (
         <>
            <Helmet>

               <title>주간 십자말풀이 - 지식포켓</title>
               <meta name="keywords" content="지식포켓, 뉴스 용어, 시사 용어, 오늘의 용어, 용어 검색, OX 퀴즈, 객관식 퀴즈, 십자말풀이, 시사 상식, 뉴스 해설, 용어 사전" />
               <meta name="description" content="매주 업데이트되는 경제·시사 십자말풀이! 재미있게 풀며 자연스럽게 상식을 익혀보세요."/>

               <meta property="og:type" content="website" />
               <meta property="og:site_name" content="지식포켓" />
               <meta property="og:title" content="주간 십자말풀이 - 지식포켓" />
               <meta property="og:description" content="매주 업데이트되는 경제·시사 십자말풀이! 재미있게 풀며 자연스럽게 상식을 익혀보세요."/>
               <meta property="og:url" content={currentUrl} />
               <meta property="og:image" content="https://cwstatic.asiae.co.kr/pocket/og_img.png" /> 
               <meta property="og:image:width" content="1200" />
               <meta property="og:image:height" content="630" />
               <meta property="og:locale" content="ko_KR" />

               <link rel="canonical" href={currentUrl}/>
               <script type="application/ld+json">
               { JSON.stringify(structureData)}
               </script>               
               
            </Helmet>         
            <main id="contents" data-page="quiz" className="page--quiz no-search-btn">
               <section className="section">
                  <div className="title-bx">
                     <h1 className="tit">퀴즈 </h1>
                  </div>
                  <></>
                  <div className="tab">
                     <ul className="tab-list">
                        <li><a href="/Today" id="tab-1" className="tab-link"> 오늘의 용어 퀴즈 </a></li>
                        <li><a href="" id="tab-2" onClick={(e) => e.preventDefault()} className="tab-link active" > 주간 십자말풀이 </a></li>
                     </ul>
                  </div>
                  <div class="quiz-week-state">
                     <div class="week-selector__text"> {formMonth}월 {formWeek}주차 </div>
                     <div type="button" class="info-toggle-btn info-toggle-btn--gray">
                        <button class="info-toggle-btn__icon" title="정보 보기"></button>
                        <div class="info-toggle-btn__toggle">
                        한 주가 두 달에 걸친 경우 <br />
                        양쪽 달에 반영돼요.
                        <button type="button" class="info-toggle-btn__close" title="정보 끄기"> </button>
                        </div>
                     </div>
                  </div>
                  <div id="quizcross">
                     <div className="crossword__state">
                        <figure>
                           <svg width="340" height="190" viewBox="0 0 340 190" xmlns="http://www.w3.org/2000/svg">
                              <path className="pie-chart-bg" d="M20 170c0-82.843 67.157-150 150-150s150 67.157 150 150" stroke="#F1F1F2" stroke-width="40" fill="none" stroke-linecap="round" />
                              <path className="pie-chart-line" d="M20 170c0-82.843 67.157-150 150-150s150 67.157 150 150" stroke="#4553E7" stroke-width="40" stroke-dasharray="471" stroke-dashoffset="471" fill="none" stroke-linecap="round" />
                           </svg>

                           <div className="percent">
                              <span className="number" data-number={this.state.solvedPercent}>{this.state.solvedPercent}</span>
                              <span className="symbol">%</span>
                           </div>
                        </figure>
                        <p className="txt">
                           {loading ? <></> : (
                              this.state.remainingCount == 10 ? ('100%를 향해 정답을 채워 봐요! 🙌') : (
                                 this.state.remainingCount > 0
                                    ? `${this.state.remainingCount}문제만 더 채우면 돼요! 🙌`
                                    : `완벽해요! 정답을 다 채웠어요 🎉`
                              ))}
                        </p>
                     </div>
                     <div className="crossword__wrap">
                        <div className="crossword">
                           {displayGrid.map((rowData, rowIndex) =>
                              rowData.map((cell, colIndex) => {
                                 const isEmpty = cell === ' ';
                                 const isFocused = this.state.focusedCells.some(fc => fc.row === rowIndex && fc.col === colIndex);

                                 // isRevealed 확인을 위해 keywords 에서 해당 셀 위치에 해당하는 항목이 있는지 찾기
                                 const revealedChar = this.state.keywords.find(word => {
                                    if (!word.isRevealed) return false;

                                    const { row, col, dir, word: w } = word;

                                    for (let i = 0; i < w.length; i++) {
                                       const r = dir === 'H' ? row : row + i;
                                       const c = dir === 'H' ? col + i : col;
                                       if (r === rowIndex && c === colIndex) {
                                          return true;
                                       }
                                    }
                                    return false;
                                 });

                                 // 해당 칸에 출력할 글자
                                 let displayChar = '';
                                 if (revealedChar) {
                                    const { row, col, dir, word: w } = revealedChar;
                                    const index = dir === 'H' ? colIndex - col : rowIndex - row;
                                    displayChar = w[index];
                                 }
                                 return (
                                    <span
                                       className={`word ${isEmpty ? 'disabled' : ''} ${!isEmpty && !revealedChar ? 'blank' : ''} ${isFocused ? 'focus' : ''}`}
                                       key={`${rowIndex}-${colIndex}`}
                                       onClick={(e) => this.handleCellClick(e, rowIndex, colIndex, isEmpty)}
                                    >
                                       {displayChar}
                                    </span>
                                 )
                              })
                           )}

                        </div>
                     </div>
                     {loginCheck == '1' ? (
                        <a href="/MyCross" className="quiz__result__txt" id="link_viewHistory" > 퀴즈 내역 보러 가기 👉 </a>
                     ) : (
                        revealedCount > 0 ? (
                           <button className="quiz__result__txt" id="link_login" onClick={() => this.handelLoginClick()}> 로그인하고 퀴즈 내역 남기기 👉 </button>
                        ) : null
                     )}
                  </div>
               </section>
               <aside className="crossword__popup" ref={this.popupRef}>
                  <div className="popup__wrap">
                     <div className="popup__head">
                        <button type="button" className="close"><span className="sr-only">닫기</span></button>
                     </div>
                     <div className="popup__body">
                        <div className="crossword__popup__bx">
                           <p className="title">
                              <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" >
                                 <rect x="0.5" y="-0.000976562" width="20" height="20" rx="4" fill="#4553E7" />
                                 <path d="M7.5 6.57901C7.5 5.27225 8.84251 3.99902 10.5 3.99902C12.1575 3.99902 13.5001 5.05682 13.5001 6.36358C13.5001 6.83443 13.3261 7.27303 13.0246 7.64197C12.1275 8.74104 10.5 9.78851 10.5 11.094" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                 <path d="M10.4883 15H10.5018" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                              {selectedWord?.dir == 'V' ? '세로' : '가로'} 퀴즈
                           </p>
                           <div className="scroll-bx">
                              <p className="desc">{selectDesc}</p>
                           </div>
                           <button className="hint-btn">
                              <span className="hint-btn__txt txt">눌러서 힌트 보기 </span>
                              <span className="hint-btn__txt hint"> {selectChoung} </span>
                           </button>
                        </div>

                        <form id="crossword__popup__input" className="crossword__popup__input">
                           <input type="text" placeholder="정답을 입력하세요" id="inputAnswer" value={this.state.answers} onChange={this.crossWordInputChange} />
                           <button type="submit" title="제출" className="btn-submit" onClick={this.crossWordCheckInput}></button>
                        </form>

                        <input type='hidden' value={this.state.quizDate} id="quizDate" />
                     </div>
                  </div>
               </aside>
            </main >
            <Footer />
         </>
      );
   }
}

export default withRouter(TodayCross);